import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl('/admin/collect');

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const unwrap = (promise) =>
  promise.then((response) => response.data).catch((error) => {
    const err = new Error(error.response?.data?.error || translateVi('Không thể kết nối server'));
    err.code = error.response?.data?.code || '';
    throw err;
  });

export const collectService = {
  getConfig: () => unwrap(axios.get(`${API_URL}/config`, getAuthHeader())),

  saveConfig: (youtubeApiKey) =>
    unwrap(axios.put(`${API_URL}/config`, { youtube_api_key: youtubeApiKey }, getAuthHeader())),

  fetchTrending: (platform, limit = 10) =>
    unwrap(axios.post(`${API_URL}/fetch`, { platform, limit }, getAuthHeader())),

  resolveLinks: (urls) => unwrap(axios.post(`${API_URL}/resolve`, { urls }, getAuthHeader())),

  importTasks: (items) => unwrap(axios.post(`${API_URL}/import`, { items }, getAuthHeader()))
};

export default collectService;
